// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getMessaging } from "firebase/messaging";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBrmpi4LoNSOdIA1FZiYlbrJoy_KKImiPE",
  authDomain: "optimist-f04f0.firebaseapp.com",
  projectId: "optimist-f04f0",
  storageBucket: "optimist-f04f0.firebasestorage.app",
  messagingSenderId: "946195402627",
  appId: "1:946195402627:web:1b85b6f90c107de3a370b6",
  measurementId: "G-F08KSBYB5D"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
export const messaging = getMessaging(app);
export default app;
